import React, { useState } from 'react'

import '../css/Home.css'

export default function Home() {
  const [slide, set_slide] = useState(1)
  let slide_el = slide === 1
               ? <div id="slide1" className="slide"></div>
               : slide === 2
               ? <div id="slide2" className="slide"></div>
               : slide === 3
               ? <div id="slide3" className="slide"></div>
               : <div id="slide4" className="slide"></div>

  return (
    <div id="home">
      <div id="slideshow">
        { slide_el }
        <div id="right-arrow" onClick={() => set_slide(slide === 4 ? 1 : slide + 1)}>
          <svg width="100%" height="100%" viewBox="4 0 16 24">
            <path fill="white" d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z"/>
          </svg>
        </div>

        <div id="left-arrow" onClick={() => set_slide(slide === 1 ? 4 : slide - 1)}>
          <svg width="100%" height="100%" viewBox="4 0 16 24">
            <path fill="white" d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"/>
          </svg>
        </div>
      </div>

      <div id="about-enoho">
        <h1>About Eneho Fikir</h1>
        <h2>Enoho Fikir & Development Organization</h2>
        <p>Eneho Fikir is a humanitarian Organization founded by 23 philanthropist friends who have been carrying out charitable activities individually. However, they have become convinced that if they put their efforts together they can bring sustainable improvements in the lives of many and started their first project with their own funding. Eneho Fikir has become a legal entity on 18th February 2019. Among other things, EHDO has embarked on a three year project aimed to enhance the learning outcomes of disadvantaged primary students in selected public schools of Addis Ababa. Addressing the nutritional needs, providing educational support through tutorial activities and educational materials, mapping out sponsorships or scholarship programs, rendering comprehensive psycho social support using professional volunteers, facilitating and assisting on income generating activities.</p>
      </div>

      <div id="mission" className="info">
        <div className="info-text">
          <h1>Our Mission</h1>
          <p>Our mission is to transform the lives of marginalized children coming from disadvantaged communities , addressing the educational, health and socio-economic problems and improve the livelihood of these segments of the society through an integrated and holistic development approach.</p>
        </div>
        <div id="mission-graphic"></div>
      </div>

      <div id="vision" className="info">
        <div className="info-text">
          <h1>Our Vision</h1>
          <p>Our vision is to Inspire humanity and promote a healthy society whereby poverty is alleviated through the integrated efforts of responsible citizens.</p>
        </div>
        <div id="vision-graphic"></div>
      </div>

      <div id="values" className="info">
        <div className="info-text">
          <h1>Our Values</h1>
          <p>We act with kindness and compassion. We respect & promote local knowledge & values of the communities that we are engaged with. We believe that kids should be nurtured with love within a healthy family and this is the foundation for a healthy society. Hence, we highly value the role & the potential of mothers in building a strong & healthy family. Hence, we believe in the empowerment of mothers so as to realize children's success.</p>
        </div>
        <div id="values-graphic"></div>
      </div>
    </div>
  )
}